import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { HashRouter } from "react-router-dom";
import Routes from "./Routes";
import "./App.css";
import { useSelector } from "react-redux";
import { updateClientConfig } from "./features/clientContext";
import { selectAccessToken, getAccessToken } from "./features/accessTokens";
import {appCues} from "./features/AppCues";

function App() {
  const clientConfigsWrapper = document.getElementById(
    "el-lead-capture-widget"
  );
  const brokerageId = clientConfigsWrapper.getAttribute("brokerageId");
  appCues(brokerageId);
  const apiKey = clientConfigsWrapper.getAttribute("apiKey"); // check if we need this
  const googleAnalyticsId = clientConfigsWrapper.getAttribute("gTagId");
  const parameters = clientConfigsWrapper.getAttribute("parameters");
  const authKey = clientConfigsWrapper.getAttribute("authKey");
  const isFullScreen = clientConfigsWrapper.getAttribute('isFullScreen') === 'true';

  const client = clientConfigsWrapper.getAttribute('prefill');
  // New Case, where we need to fetch the zc and rc from URL
  const zipCode = client ? window.location.search.split('&')[0].split('=')[1] : "";
  // Previous Case
  // const zipCode = clientConfigsWrapper.getAttribute('zipCode');
  const commodity = clientConfigsWrapper.getAttribute('commodity');
  const referralCode = client ? window.location.search.split('&')[1].split('=')[1].replaceAll('%20', ' ') : "";
  const domainTerm = client ? window.location.search.split('&')[2].split('=')[1] : "";
  const usage= clientConfigsWrapper.getAttribute('usage');
  const rateClass = clientConfigsWrapper.getAttribute('rateClassification');


  const accessToken = useSelector(selectAccessToken);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      updateClientConfig({ brokerageId, apiKey, googleAnalyticsId, authKey, isFullScreen,parameters, client, zipCode, commodity, referralCode, domainTerm, usage, rateClass })
    );
  }, [dispatch, apiKey, brokerageId, googleAnalyticsId, authKey, isFullScreen,parameters]);

  useEffect(() => {
    if (authKey && brokerageId) dispatch(getAccessToken());
  }, [authKey, brokerageId, dispatch]);

  return (
    accessToken && (
      <HashRouter>
        <Routes />
      </HashRouter>
    )
  );
}

export default App;
